<app-section-banner [title]="'about.title' | translate" [backgroundImage]="'assets/img/banner_about.png'">
</app-section-banner>

<section class="flex flex-col md:flex-row items-center justify-center bg-white py-0 relative max-w-screen-xl mx-auto">
	<!-- Image container with picture and lazy loading -->
	<div class="w-full  h-auto  xl:w-[542px] xl:h-[480px]">
		<picture>
			<!-- WebP image format for modern browsers -->
			<source srcset="assets/webp/soluciones-small.webp 320w, 
                      assets/webp/soluciones-medium.webp 640w, 
                      assets/webp/soluciones-large.webp 1024w, 
                      assets/webp/soluciones-xlarge.webp 1280w" type="image/webp">

			<!-- Fallback for browsers that don't support WebP -->
			<source srcset="assets/img/soluciones-small.png 320w, 
                      assets/img/soluciones-medium.png 640w, 
                      assets/img/soluciones-large.png 1024w, 
                      assets/img/soluciones-xlarge.png 1280w" type="image/png">

			<!-- Default image if the browser doesn't support either WebP or PNG -->
			<img src="assets/img/soluciones.png" class="w-full h-full object-cover"
				alt="Escritorio moderno que simboliza soluciones digitales innovadoras" loading="lazy">
		</picture>
	</div>

	<!-- Adjusted text container -->
	<div
		class="flex-none w-full md:w-1/2 h-auto xl:w-[542px] xl:h-[480px] bg-white flex items-center justify-center md:p-2 p-6">
		<div
			class="flex flex-col items-center md:items-start text-[#020042] w-full md:space-y-2 space-y-4 md:ml-2 lg:ml-6">
			<img src="assets/svg/about/icono-home-01.svg" alt="Icono de timon"
				class="w-[38.15px] h-[43px] mb-4 md:mb-0 lg:ml-6" loading="lazy">
			<h2
				class="font-bold lg:text-[24px] md:text-[18px] leading-[36px]  md:leading-[39px] text-center md:text-left lg:ml-6 tracking-wider">
				<span class="block w-full">{{ 'about.title.part1' | translate }} </span>
				<span class="block w-full">i{{ 'about.title.part2' | translate }}</span>
			</h2>
			<div class="w-full">
				<p
					class="text-[14px] leading-[21px] md:text-[12px] md:leading-[18px] text-justify lg:ml-6 mt-4 w-full md:w-auto max-w-full md:max-w-[380px] ">
					{{ 'about.description' | translate }}
				</p>
			</div>
		</div>
	</div>
</section>
<section #statsSection class="relative py-16 bg-cover bg-center text-white"
	style="background-image: url('assets/webp/experiencia.webp'); background-color: #1f1f1f;">
	<div class="container mx-auto flex justify-center">
		<div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-4 gap-6">
			<!-- Years of Experience -->
			<div
				class="relative bg-transparent border border-white p-4 flex flex-col items-center justify-center h-48 w-full mx-auto">
				<div class="flex flex-col items-center space-y-1">
					<div class="flex items-center justify-center space-x-2">
						<span class="text-2xl font-regular font-poppins tracking-wider">{{ 'numbers.experience' | translate }}</span>
						<p class="text-sm font-extralight font-poppins tracking-wider whitespace-nowrap">{{ 'stats.experience' | translate }}
					</div>
				</div>
				<div class="flex items-center justify-center space-x-1 mt-1">
					<img src="assets/svg/arq-it/copa.svg" alt="Anos de Experiencia" class="w-10 h-10">
					<span class="text-lg font-extralight font-poppins">&#8211;</span>
					<p class="text-lg font-extralight font-poppins tracking-wide">{{ experienceYears }}</p>
				</div>
			</div>

			<!-- Satisfied Clients -->
			<div
				class="relative bg-transparent border border-white p-4 flex flex-col items-center justify-center h-48 w-full mx-auto">
				<div class="flex flex-col items-center space-y-1">
					<div class="flex items-center justify-center space-x-2">
						<span class="text-2xl font-regular font-poppins tracking-wider">{{ 'numbers.satisfiedClients' | translate }}</span>
						<p class="text-sm font-extralight font-poppins tracking-wider whitespace-nowrap">{{ 'stats.satisfiedClients' | translate }}</p>
					</div>
				</div>
				<div class="flex items-center justify-center space-x-1 mt-1">
					<img src="assets/svg/arq-it/smile.svg" alt="Clientes Satisfechos" class="w-10 h-10">
					<span class="text-lg font-extralight font-poppins">&#8211;</span>
					<p class="text-lg font-extralight font-poppins tracking-wide">{{ satisfiedClients }}</p>
				</div>
			</div>

			<!-- Completed Projects -->
			<div
				class="relative bg-transparent border border-white p-4 flex flex-col items-center justify-center h-48 w-full mx-auto">
				<div class="flex flex-col items-center space-y-1">
					<div class="flex items-center justify-center space-x-2">
						<span class="text-2xl font-regular font-poppins tracking-wider">{{ 'numbers.completedProjects' | translate }}</span>
						<p class="text-sm font-extralight font-poppins tracking-wider whitespace-nowrap">{{ 'stats.completedProjects' | translate }}</p>
					</div>
				</div>
				<div class="flex items-center justify-center space-x-1 mt-1">
					<img src="assets/svg/arq-it/maleta.svg" alt="Proyectos Completados" class="w-12 h-12">
					<span class="text-lg font-extralight font-poppins">&#8211;</span>
					<p class="text-lg font-extralight font-poppins tracking-wide">{{ completedProjects }}</p>
				</div>
			</div>

			<!-- Cups of Coffee -->
			<div
				class="relative bg-transparent border border-white p-4 flex flex-col items-center justify-center h-48 w-full mx-auto">
				<div class="flex flex-col items-center space-y-1">
					<div class="flex items-center justify-center space-x-2">
						<span class="text-2xl font-regular font-poppins tracking-wider">{{ 'numbers.coffeeCups' | translate }}</span>
						<p class="text-sm font-extralight font-poppins tracking-wider whitespace-nowrap">{{ 'stats.coffeeCups' | translate }}</p>
					</div>
				</div>
				<div class="flex items-center justify-center space-x-1 mt-1">
					<img src="assets/svg/arq-it/taza.svg" alt="Tazas de Caf�" class="w-12 h-12">
					<span class="text-lg font-extralight font-poppins">&#8211;</span>
					<p class="text-lg font-extralight font-poppins tracking-wide">{{ coffeeCups }}</p>
				</div>
			</div>
		</div>
	</div>
</section>


<section>
	<div class="container max-w-6xl mx-auto justify-center">
		<div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-0">
			<!-- Title and subtitle spanning 2 columns -->
			<div
				class="col-span-1 md:col-span-2 text-white h-full mb-4 flex flex-col items-center justify-center bg-[#5173EF] hover:bg-[#3D5AFE] py-6 px-4 md:px-6">
				<h2 class="text-2xl text-[#F2F4FE] mb-4 text-center">{{ 'values.title' | translate }}</h2>
				<p class="text-sm italic mb-8 text-center">{{ 'values.slogan' | translate }}</p>
			</div>

			<!-- Innovation Box -->
			<div class="relative h-64 bg-[#CBD6FC] text-[#020042] p-6 transition-all duration-300 hover:bg-[#A0C4FF] group flex flex-col items-center justify-center"
				role="group" aria-label="Valor corporativo: Innovación. Innovamos para crecer.">
				<img src="assets/svg/arq-it/innovacion.svg" alt="Innovaci&oacute;n"
					class="mx-auto mb-4 w-10 h-10 group-hover:hidden" loading="lazy">
				<p class="text-base  group-hover:hidden">{{ 'values.innovation' | translate }}</p>
				<h4 class="text-base lg:text-sm xl:text-base hidden group-hover:block">{{ 'values.innovation_description' | translate }}</h4>
			</div>

			<!-- Dedication Box -->
			<div class="relative h-64 bg-[#F2F4FE] text-[#020042] p-6 transition-all duration-300 hover:bg-[#E5EBFF] group flex flex-col items-center justify-center"
				role="group" aria-label="Valor corporativo: Dedicación. Nos dedicamos con pasión.">
				<img src="assets/svg/arq-it/pasion.svg" alt="Dedicaci&oacute;n"
					class="mx-auto mb-4 w-8 h-8 group-hover:hidden" loading="lazy">
				<h3 class="text-base group-hover:hidden">{{ 'values.dedication' | translate }}</h3>
				<h4 class="text-base lg:text-sm xl:text-base hidden group-hover:block">{{ 'values.dedication_description' | translate }}
				</h4>
			</div>

			<!-- Permanence Box -->
			<div class="relative h-64 bg-[#020042] text-[rgba(255,255,255,0.9)] p-6 transition-all duration-300 hover:bg-[#1A237E] group flex flex-col items-center justify-center"
				role="group" aria-label="Valor corporativo: Permanencia. Comprometidos a largo plazo.">
				<img src="assets/svg/arq-it/permanencia.svg" alt="Permanencia"
					class="mx-auto mb-4 w-10 h-10 group-hover:hidden" loading="lazy">
				<h4 class="text-base group-hover:hidden">{{ 'values.permanence' | translate }}</h4>
				<h4
					class="text-base lg:text-sm xl:text-base hidden group-hover:block whitespace-nowrap overflow-hidden text-ellipsis">
					{{ 'values.permanence_description' | translate }}</h4>
			</div>

			<!-- Renewal Box -->
			<div class="relative h-64 bg-[#CBD6FC] text-[#020042] p-6 transition-all duration-300 hover:bg-[#A0C4FF] group flex flex-col items-center justify-center"
				role="group" aria-label="Valor corporativo: Renovación. Reinvención continua.">
				<img src="assets/svg/arq-it/renovacion.svg" alt="Renovaci&oacute;n"
					class="mx-auto mb-4 w-8 h-8 group-hover:hidden" loading="lazy">
				<h4 class="text-base group-hover:hidden">{{ 'values.renewal' | translate }}</h4>
				<h4 class="text-base lg:text-sm xl:text-base hidden group-hover:block">{{ 'values.renewal_description' | translate }}</h4>
			</div>

			<!-- Excellence Box -->
			<div class="relative h-64 bg-[#F2F4FE] text-[#020042] p-6 transition-all duration-300 hover:bg-[#E5EBFF] group flex flex-col items-center justify-center"
				role="group" aria-label="Valor corporativo: Excelencia. Buscamos la excelencia.">
				<img src="assets/svg/arq-it/excelencia.svg" alt="Excelencia"
					class="mx-auto mb-4 w-10 h-10 group-hover:hidden" loading="lazy">
				<h4 class="text-base group-hover:hidden">{{ 'values.excellence' | translate }}</h4>
				<h4 class="text-base lg:text-sm xl:text-base hidden group-hover:block">{{ 'values.excellence_description' | translate }}</h4>
			</div>

			<!-- Creativity Box -->
			<div class="relative h-64 bg-[#020042] text-[rgba(255,255,255,0.9)] p-6 transition-all duration-300 hover:bg-[#1A237E] group flex flex-col items-center justify-center"
				role="group" aria-label="Valor corporativo: Creatividad. Creatividad constante.">
				<img src="assets/svg/arq-it/creatividad.svg" alt="Creatividad"
					class="mx-auto mb-4 w-8 h-8 group-hover:hidden" loading="lazy">
				<h4 class="text-base group-hover:hidden">{{ 'values.creativity' | translate }}</h4>
				<h4 class="text-base lg:text-sm xl:text-base hidden group-hover:block">{{ 'values.creativity_description' | translate }}</h4>
			</div>
		</div>
	</div>
</section>

<app-technologies></app-technologies>